export { default } from './IconPickerCDS';
